// extracted by mini-css-extract-plugin
export var cardDescription = "ClinicalResearch-module--cardDescription---jk2Q";
export var cardJournal = "ClinicalResearch-module--cardJournal--qwrU2";
export var cardTitle = "ClinicalResearch-module--cardTitle--lvw92";
export var carouselCard = "ClinicalResearch-module--carouselCard--fCY4D";
export var headerSection = "ClinicalResearch-module--headerSection--LUGXN";
export var mainTitle = "ClinicalResearch-module--mainTitle--OOcuo";
export var whatTwinDoWrapper = "ClinicalResearch-module--whatTwinDoWrapper--A8HWg";